(function(){
    'use strict';
    
    // check if the progress section exists
    var progress_section_exists = !!document.querySelector('.progress-section__wrapper');

    // if the progress section exists do stuff
    if (progress_section_exists) {

        // get all progress sections
        var progress_sections = document.querySelectorAll('.progress-section__wrapper');

        // loop through all progress sections
        for (var i = 0; i < progress_sections.length; i++) {

            progress_sections[i].querySelector('.progress-section__gpa__reveal').addEventListener('click', function(){

                this["classList"].toggle('progress-section__gpa__reveal--shown');

            });
            
        }

    }
    
}());
